import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { MailService, MessageData } from 'src/services/mail.service';
declare let $: any;
interface ContactItem {

    icon: string;

    title: string;

    lines: string[];

}

@Component({
    selector: 'app-contact-section-redesign',
    templateUrl: './contact-section-redesign.component.html',
    styleUrls: ['./contact-section-redesign.component.scss'],
    providers: [MailService]
})
export class ContactSectionRedesignComponent implements OnInit {

    form: any;
    sending: boolean = false;
    error: boolean = false;
    mailResult: any;
    constructor(private mail: MailService,
        private fb: UntypedFormBuilder) {

    }


    ngOnInit() {
        this.resetForm();
    }

    private resetForm() {
        this.form = this.fb.group({
            name: [null, Validators.required],
            email: [null, Validators.required],
            company: [null, Validators.required],
            phone: null,
            subject: [null, Validators.required],
            disabled: false,
            message: [null, Validators.required],
        });
    }

    /* ==========================================
        Header
    ========================================== */

    eyebrow = 'GET IN TOUCH';

    title = 'Let’s start the conversation';

    description =
        'Whether you have questions about our platform, want to talk to our team, or simply want to learn more about us, our team is here to help.';

    /* ==========================================
        Contact Information
    ========================================== */

    contactItems: ContactItem[] = [

        {
            icon: '/assets/img/redesign/contact/location.svg',
            title: 'Addresses',
            lines: [
                '35 Woodlark road, Newbury, RG142FY, UK',
                'Harju maakond, Tallinn, Nõmme linnaosa, Pärnu mnt 388b, 11612, ESTONIA'
            ]
        },

        {
            icon: '/assets/img/redesign/contact/email.svg',
            title: 'Email',
            lines: [
                'sales@altheasoft.com',
                'support@altheasoft.com'
            ]
        },

        {
            icon: '/assets/img/redesign/contact/phone.svg',
            title: 'Phone',
            lines: [
                '+44 333 224 8250'
            ]
        },

        {
            icon: '/assets/img/redesign/contact/clock.svg',
            title: 'Business Hours',
            lines: [
                'Monday - Friday',
                '8:00 AM - 5:00 PM'
            ]
        }

    ];

    /* ==========================================
        Form
    ========================================== */

    formTitle = 'Send us a message';

    firstNamePlaceholder = 'Full Name';

    phonePlaceholder = 'Phone';

    emailPlaceholder = 'Email Address';

    companyPlaceholder = 'Company';

    subjectPlaceholder = 'Subject';

    messagePlaceholder = 'Tell us how we can help you...';

    submitButton = 'Send Message';

    /* ==========================================
        Map
    ========================================== */

    mapTitle = 'Visit our office';

    mapDescription =
        'Our headquarters are located in the heart of San Francisco. Schedule a meeting or stop by to learn more about our solutions.';

    mapEmbed =
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.086823112826!2d-122.40136928468141!3d37.79361797975633!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80858064df0f7f4d%3A0x1f8b9f3dcd89f5cb!2sSalesforce%20Tower!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus';

    /* ==========================================
        TrackBy
    ========================================== */

    trackByIndex(index: number): number {

        return index;

    }

    send() {
        this.error = false;
        this.mailResult = null;
        this.startSpinning();
        let msg = new MessageData();
        msg.subject = this.form.controls['subject'].value;
        msg.textData = 'Company: ' + this.form.controls['company'].value + '<br>' + 'Phone: ' + this.form.controls['phone'].value + '<br>' + this.form.controls['name'].value + '<br>' + this.form.controls['email'].value + '<br>' + this.form.controls['message'].value;
        this.mail.send(msg).subscribe({
            next: (result: any) => {
                console.log(result);
                this.stopSpinning();
                this.resetForm();
                this.error = result.code < 0;
                this.mailResult = result.code > 0 
                                     ? 'Your message was sent correctly! Our team will answer you as soon as possible'
                                     : 'There was an error sending your email, please retry later.';
            },
            error: (error) => {
                console.log(error);
                this.stopSpinning();
                this.mailResult = 'There was an error sending your email, please retry later.';
                console.log(error);
                this.error = true;
            }
        });
    }


    startSpinning() {
        this.sending = true;
        $('.preloader-flex').fadeIn('slow');
    }

    stopSpinning() {
        this.sending = false;
        $.getScript('assets/js/custom.js');
        $('.preloader-flex').fadeOut('slow');
    }
}